module.exports = __webpack_public_path__ + "img/report__arrow.d8985238.svg";